<template>
  <div class="home-page-container">
    <!-- 主要内容区 -->
    <div class="main-content">
      <!-- 走进欧曼谛部分 -->
      <section class="about-section">
        <div class="title-wrapper">
          <h1 class="chinese-title">走进欧曼谛</h1>
          <h2 class="english-title">ENTER ON-MIND</h2>
        </div>

        <div class="content-row">
          <div class="text-content">
            <div class="paragraph-container">
              <p class="paragraph">
                山东欧曼谛时尚美业学校(隶属中国东方教育集团)深耕美业教育38年，坐落于省会济南市中心，地理位置优越，周边交通便捷、环境优美且生活配套完善。学校拥有两大现代化校区，构建"教学-实训-生活"全链条生态体系，以"缔造时尚，专研美学"为使命，打造集技能培养、职教高考、国际认证于一体的特色教育模式，并与3万余家知名企业建立人才输送合作，稳居行业标杆。
              </p>
              <p class="paragraph">
                学校引进全球标准课程体系，建设世界技能大赛实训基地、智能教室及行业首创校内美学馆；创新"美学-驱动-教学"模式，将潮流理念融入专业课程，配备国际赛事级教学设施，同步前沿技术与流行趋势；实行"技能+升学"双通道培养，保障名企就业与职教高考路径，配套星级生活设施并汇聚顶尖师资团队，全方位护航学生成长。
              </p>
            </div>
          </div>

          <div class="image-content">
            <img src="@/assets/home1.png" alt="欧曼谛环境" class="about-image">
          </div>
        </div>
      </section>

      <!-- 学校文化部分 -->
      <section class="culture-section">
        <div class="culture-bg">
          <h1 class="section-title">学校文化</h1>
          <div class="culture-items">
            <div class="culture-item">

              <p class="culture-title">办学愿景</p>
              <p class="culture-desc">办世界最好的美业教育</p>
            </div>
            <div class="culture-item">

              <p class="culture-title" style="color: rgb(208, 38, 74);">学校使命</p>
              <p class="culture-desc" style="color: rgb(208, 38, 74);">
                高端时尚美业教育<br>标准制定者
              </p>
            </div>
            <div class="culture-item">

              <p class="culture-title">办学定位</p>
              <p class="culture-desc">缔造时尚 专研美学</p>
            </div>
            <div class="culture-item">

              <p class="culture-title">办学理念</p>
              <p class="culture-desc">
                以赛立校、技能强校、文化兴校
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- 品牌优势部分 -->
      <section class="advantages-section">
        <div class="advantages-header">
          <h1 class="bg-text">ON MIND</h1>
          <h1 class="section-title">一地学习，全国就业</h1>
        </div>
        <div :style="{
          backgroundImage: `url(${require('@/assets/ditu.jpg')})`,
          height: '800px',
          width: '100%',
          backgroundSize: 'contain',  // 核心：缩小图片至容器内完整显示
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',  // 背景图片在容器中居中显示
          backgroundAttachment: 'scroll'  // 滚动时背景随容器移动（可选，避免固定导致错位 
        }"></div>
      </section>
    </div>
  </div>
</template>

<script>
import HomePage from '@/js/HomePage';
export default {
  ...HomePage
}
</script>

<style scoped>
/* 基础重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 主容器样式 - 统一间距 */
.home-page-container {
  width: 100%;
  padding: 60px 20px;
  margin: -60px 0 0 0;
}

/* 主要内容区样式 */
.main-content {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
}

/* 通用标题样式 */
.section-title {

  font-size: 28px;
  font-weight: 600;
  margin: 40px 0;
  position: relative;
  text-align: center;
}

/* 标题部分样式 - 紧凑排列 */
.title-wrapper {
  margin-bottom: 30px;
  position: relative;
  padding-left: 20px;
}

.title-wrapper::before {
  content: "";
  position: absolute;
  left: 0;
  top: 5px;
  bottom: 5px;
  width: 4px;
  background-color: #E0224D;
}

.chinese-title {
  color: rgb(59, 51, 53);
  font-size: 28px;
  font-weight: 600;
  margin: 0 0 5px 0;
  line-height: 1.2;
}

.english-title {
  color: #E0224D;
  font-size: 16px;
  font-weight: 500;
  margin: 0;
  font-family: 'Arial', sans-serif;
  letter-spacing: 1px;
  text-transform: uppercase;
}

/* 走进欧曼谛部分 - 统一间距 */
.about-section {
  margin-bottom: 60px;
}

.content-row {
  display: flex;
  align-items: flex-start;
  gap: 40px;
}

.text-content {
  flex: 1;
}

.paragraph-container {
  width: 100%;
  margin-bottom: 20px;
}

.paragraph {
  text-indent: 2em;
  color: rgb(59, 51, 53);
  line-height: 1.8;
  margin-bottom: 20px;
  font-size: 16px;
  text-align: justify;
}

.image-content {
  flex: none;
}

.about-image {
  width: 500px;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 学校文化部分 - 统一间距 */
.culture-section {
  margin: 50px 0;
}

.culture-bg {
  background: url('@/assets/1123.png') no-repeat center center/100% 80%;
  padding: 40px 0px 80px 0;
}

.culture-items {
  display: flex;
  justify-content: center;
  gap: 50px;
  margin-top: 40px;
}

.culture-item {
  text-align: center;
  min-width: 180px;
}

.culture-item img {
  margin-bottom: 20px;
  height: 80px;
  width: auto;
}

.culture-title {
  font-weight: bold;
  margin-bottom: 12px;
  font-size: 18px;
    color: #e0224d;
}

.culture-desc {
  line-height: 1.6;
  font-weight: bold;
  font-size: 16px;
   color: #e0224d;
}

/* 品牌优势部分 - 统一间距
.advantages-section {
  margin: 30px 0;
} */

.advantages-header {

  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bg-text {
  position: absolute;
  color: rgb(235, 235, 235);
  font-size: 80px;
  z-index: 1;
}

.advantages-header .section-title {
  position: relative;
  z-index: 2;
  margin: 0;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .about-image {
    width: 450px;
  }

  .culture-items {
    gap: 40px;
  }
}

@media (max-width: 992px) {
  .home-page-container {
    padding: 50px 15px;
  }

  .content-row {
    flex-direction: column;
    gap: 30px;
  }

  .about-image {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
  }

  .culture-items {
    flex-wrap: wrap;
    gap: 30px;
  }

  .culture-item {
    min-width: 160px;
  }
}

@media (max-width: 768px) {
  .section-title {
    font-size: 24px;
    margin: 30px 0;
  }

  .chinese-title {
    font-size: 22px;
  }

  .english-title {
    font-size: 14px;
  }

  .bg-text {
    font-size: 60px;
  }

  .culture-bg {
    padding: 40px 0;
  }

  .culture-item {
    min-width: 140px;
  }


}

@media (max-width: 576px) {
  .home-page-container {
    padding: 40px 10px;
  }

  .paragraph {
    font-size: 15px;
    line-height: 1.7;
  }

  .culture-items {
    gap: 20px;
  }

  .culture-item {
    min-width: 120px;
  }

  .culture-item img {
    height: 60px;
    margin-bottom: 15px;
  }

  .culture-title {
    font-size: 16px;
  }

  .culture-desc {
    font-size: 14px;
  }

  .bg-text {
    font-size: 40px;
  }

  .advantages-header {
    height: 140px;
  }
}
</style>